import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    imports: [TranslateModule, ReactiveFormsModule]
})
export class SearchFieldComponent implements OnInit {

  @Output()
  public searchTextChanged = new EventEmitter<string>();

  @Input()
  public placeholderText = 'i18n.shared.search';

  public searchForm = this.fb.group({
    filter: this.fb.control<string>(null),
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.searchForm.get('filter').valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(val => {
        this.searchTextChanged.emit(val);
      });
  }
}
